'use client';

import { Content, PopoverArrow, TriggerButton } from './Popover.style';
import { ChevronSvg, NavContent } from './shared.style';
import * as RadixPopover from '@radix-ui/react-popover';
import { desktopBreakpoint } from '@thrivent/midwest-shared';
import { useEffect, useState } from 'react';
import { useMedia } from 'react-use';

type Props = {
  children: React.ReactNode;
  text: string;
};

export const Popover = ({ children, text }: Props) => {
  const [open, setOpen] = useState(false);

  const isMobile = useMedia(`(max-width: ${desktopBreakpoint}px)`, false);

  useEffect(() => {
    if (isMobile) {
      setOpen(false);
    }
  }, [isMobile]);

  // using ts-ignore to avoid type issues with RadixPopover.Trigger. Need to pass aria-controls as null to remove aria-controls
  return (
    <RadixPopover.Root open={open} onOpenChange={setOpen}>
      {/* @ts-ignore */}
      <TriggerButton aria-controls={null}>
        <NavContent>
          <span>{text}</span>
          <ChevronSvg
            width="17px"
            height="17px"
            viewBox="0 0 12 12"
            focusable="false"
            aria-hidden
            xmlns="http://www.w3.org/2000/svg"
            $isActive={open}
          >
            <path d="M8.3 8 6 5.7 3.7 8 3 7.3l3-3 3 3-.7.7z" />
          </ChevronSvg>
        </NavContent>
      </TriggerButton>
      <RadixPopover.Portal aria-label={`${text} navigation menu`}>
        <Content
          aria-label="popover-portal"
          collisionPadding={{ left: 20, right: 20 }}
          align="start"
        >
          {children}
          <PopoverArrow aria-hidden="true" />
        </Content>
      </RadixPopover.Portal>
    </RadixPopover.Root>
  );
};
